import React from "react";
import "./Genesis.css";

const Genesis = () => {
  return (
    <div className="genesis">
      <div className="wrapper">
        <div className="genesis-intro-heading">
          <h2>Geneza, problematyka</h2>
        </div>
      </div>
      <div className="genesis-specialization">
        <h3>Geneza</h3>
        <p>
          <mark>Stanisław Wyspiański</mark> napisał „Wesele” w&nbsp;
          <mark>1900</mark> roku. Bezpośrednią inspiracją do&nbsp;powstania
          sztuki był ślub poety Lucjana Rydla i&nbsp;chłopki Jadwigi
          Mikołajczykówny. Wesele państwa młodych odbyło się w&nbsp;dworku
          Włodzimierza Tetmajera i&nbsp;jego żony Anny w&nbsp;podkrakowskich
          Bronowicach. Na przyjęciu zgromadziła się cała elita intelektualna
          i&nbsp;artystyczna ówczesnego Krakowa. Wśród gości byli między innymi
          sam&nbsp;
          <mark>Wyspiański, Kazimierz Tetmajer czy Tadeusz Boy-Żeleński</mark>.
          Była również obecna cała zaproszona wieś, ślub stanowił bowiem
          mezalians i&nbsp;wpisywał się w&nbsp;
          <mark>młodopolską chłopomanię</mark>.
        </p>
        <br />
        <h3>Czas i&nbsp;miejsce akcji</h3>
        <p>
          Akcja „Wesela” rozgrywa się w&nbsp;
          <mark>listopadową noc w&nbsp;1900 roku</mark>, w&nbsp;dworku
          Tetmajerów, w&nbsp;podkrakowskich <mark>Bronowicach</mark>.
        </p>
        <br />
        <h3>Motywy</h3>
        <h4>Motyw wesela</h4>
        <p>
          to główna rama tematyczna dramatu, stanowiąca tło dla wszystkich
          wydarzeń. Wesele inteligenta i&nbsp;chłopki stanowi również
          wymowny&nbsp;
          <mark>symbol zbratania obu stanów</mark>.
        </p>
        <h4>Motyw tańca</h4>
        <p>
          taniec pojawia się w&nbsp;„Weselu” w&nbsp;różnych odsłonach,
          najbardziej istotny jest jednak <b>chocholi taniec </b>
          z&nbsp;finałowej sceny dramatu –&nbsp;
          <mark>symbol narodowego marazmu i&nbsp;bezsilności</mark>.
        </p>
        <h4>Motyw ducha</h4>
        <p>
          drugi akt dramatu stanowi swoisty seans zjaw i&nbsp;duchów:
          <b> Widma, Rycerza, Stańczyka, Upiora i&nbsp;Wernyhory</b>.
        </p>
        <h4>Motyw walki o&nbsp;wolność</h4>
        <p>
          Wernyhora zjawia się, żeby przygotować zbrojne powstanie. Nie udaje
          się to jednak, ponieważ <b>Jasiek</b> gubi <b>złoty róg</b>.
        </p>
        <br />
        <h3>Problematyka</h3>
        <p>
          „Wesele” stanowi najważniejszy młodopolski dramat. Dzieło ma
          charakter&nbsp;
          <mark>symboliczny</mark>, tytułowe wesele posłużyło Wyspiańskiemu
          jako&nbsp;
          <mark>
            pretekst do poruszenia najważniejszych spraw narodowych. Dramat
            stanowi zatem wypowiedź na temat trudnych relacji chłopów
            i&nbsp;szlachty, polskich przywar, a&nbsp;także tragicznej historii
            nieudanych powstań
          </mark>
          . Szczególnie mocno podkreśla autor miałkość pseudopatriotycznych
          wywodów, które nie znajdują potwierdzenia w&nbsp;czynach.
          Pesymistycznym symbolem jest zgubienie <b>złotego rogu </b>
          przez <b>Jaśka</b> i&nbsp;smętny
          <b> chocholi taniec</b> weselników, obrazujący marazm polskiego
          narodu. Jest również „Wesele” swoistą rozprawą z&nbsp;
          <mark>młodopolską chłopomanią i&nbsp;dekadentyzmem</mark>.
        </p>
        <br />
        <p>
          <em>
            wypracowania.pl/lektury/wesele-opracowanie-problematyka-bohaterowie
          </em>
        </p>
      </div>
    </div>
  );
};

export default Genesis;
